import { HistoryUi } from './history-api.types';
import { TableData } from '../../../../shared/types/api-response.types';

export type HistoryUpdateData = {
  DeviceSpecInfo?: unknown;
  [key: string]: unknown;
};

export type DeviceAttribute = {
  AttributeType: 'Configuration';
  Name: 'MeterPressureLowLow';
  Value: string;
};

export type HistoryValues = {
  DeviceStatus?: { DeviceStatusValue: string };
  DeviceAttributes?: any[];
  StatusComponents?: any[];
  value: string;
  CommDeviceSoftware?: string;
  Status?: string;
};

export type HistoryTableData = TableData<HistoryUi>;

export interface AttributeUpdatedValue {
  name: string;
  oldValue: string | number | null;
  newValue: string | number | null;
}

export type HistoryUpdate = {
  tag?: string | null;
  value: string | null;
  status?: string | null;
} | null;

export enum AlarmStatus {
  Cleared,
  Active
}
